import axios from 'axios'
import { BASE_URL } from './constant'

const api = axios.create({
  baseURL: BASE_URL,
  headers: {
    'Content-Type': 'application/json',
  },
})

api.interceptors.request.use(
  (config) => {
    const token = sessionStorage.getItem('token')
    console.log('token', token)
    if (token) {
      config.headers.Authorization = `Bearer ${token}`
    }
    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

// Optional: Response interceptor for global error handling (e.g., token expiry)
api.interceptors.response.use(
  (response) => response,
  (error) => {
    if (error.response?.status === 401) {
      // Handle unauthorized: Clear storage and redirect to login
      sessionStorage.clear()
      window.location.href = '/login' // Or use navigate from react-router if in a component
    }
    return Promise.reject(error)
  }
)

export default api
